import { useLayoutEffect, useState } from "react";

/**
 * ResizeObserver size tracking deferred to the next animation frame so
 * layout updates from state (clip-path, min-height, etc.) do not trigger
 * "ResizeObserver loop completed with undelivered notifications".
 */
export function useElementBox(ref, observe = true) {
  const [dim, setDim] = useState({ w: 0, h: 0 });

  useLayoutEffect(() => {
    if (!observe) {
      setDim({ w: 0, h: 0 });
      return undefined;
    }

    const el = ref.current;
    if (!el) return undefined;

    let rafId = 0;

    const schedule = () => {
      cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(() => {
        rafId = 0;
        if (!el.isConnected) return;
        const r = el.getBoundingClientRect();
        const w = Math.floor(r.width);
        const h = Math.floor(r.height);
        setDim((prev) => (prev.w === w && prev.h === h ? prev : { w, h }));
      });
    };

    schedule();
    const ro = new ResizeObserver(schedule);
    ro.observe(el);

    return () => {
      cancelAnimationFrame(rafId);
      ro.disconnect();
    };
  }, [observe]); // eslint-disable-line react-hooks/exhaustive-deps -- ref identity stable

  return dim;
}
